import { Printer } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import type { GetPrintingRequestsForPatient } from '@virtual-care/client';
import { ReservationStatus } from '@virtual-care/ui';

export function PrintingRequestCard({
  record,
}: {
  record: GetPrintingRequestsForPatient['records'][number];
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const doctorName = record.doctor
    ? `${record.doctor.firstName} ${record.doctor.lastName}`
    : undefined;

  return (
    <div
      className="cursor-pointer rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md"
      onClick={() => navigate(`/printing/${record.id}`)}
    >
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-chart-4 flex h-6 w-6 items-center justify-center rounded-full">
            <Printer className="h-4 text-white" />
          </div>
          <div className="flex flex-col items-start gap-1">
            <span className="font-bold text-black">
              {t('printing.cards.prefix')} {record.counter}#
            </span>
            <ReservationStatus.Root status={record.status}>
              <ReservationStatus.Indicator />
              <ReservationStatus.Label render={(meta) => t(meta.key)} />
            </ReservationStatus.Root>
          </div>
        </div>
      </div>
      {doctorName && (
        <p className="text-sm">
          <span className="text-muted-foreground">
            {t('printing.cards.doctorName')}:
          </span>{' '}
          <span className="font-semibold">{doctorName}</span>
        </p>
      )}
    </div>
  );
}
